<div class="sidebar-panel">
  <div id="sidebar-top-scroll-area" class="layout__navigation">
    <app-sidenav [menuItems]="menuItems" />
  </div>
</div>